import React, { useState } from 'react';
import _get from 'lodash/get';
import { Paper, makeStyles, Button } from '@material-ui/core';
import { courseSharedStyles } from '../courseSharedStyles';

const useStyles = makeStyles({
  video: {
    width: '100%',
  },
  bottomContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    marginTop: 15,
  },
  button: {
    padding: '10px 16px',
    borderRadius: 20,
    minWidth: 106,
    border: '1px solid transparent',
    marginLeft: 10,
  },
  ...courseSharedStyles(),
});

export const WelcomeSeries = ({
  series,
  completeWelcomeSeries,
  seriesSiteCopy,
}) => {
  const classes = useStyles();
  const [hasVideoPlayed, setHasVideoPlayed] = useState(false);

  const onVideoPlay = () => {
    setHasVideoPlayed(true);
  };

  const assets = _get(series, 'fields.assets') || [];
  const video = assets.find(asset =>
    _get(asset, 'fields.file.contentType').includes('video'),
  );

  return (
    <Paper elevation={0} className={classes.videoPaper}>
      {video && (
        <video onPlay={onVideoPlay} className={classes.video} controls>
          <source
            src={video.fields.file.url}
            type={video.fields.file.contentType}
          />
        </video>
      )}
      {hasVideoPlayed && (
        <div className={classes.bottomContainer}>
          <Button
            className={classes.button}
            variant="contained"
            color="primary"
            onClick={completeWelcomeSeries}
          >
            {_get(seriesSiteCopy, 'pageCopy.next')}
          </Button>
        </div>
      )}
    </Paper>
  );
};
